import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17e063b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "SearchDetail" }
const _hoisted_2 = { class: "SearchDetail_Container" }
const _hoisted_3 = { class: "SearchDetail_Contents" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "取次", -1))
const _hoisted_5 = { class: "SearchDetail_Contents_List" }
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "SearchDetail_Contents" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "書店", -1))
const _hoisted_10 = { class: "SearchDetail_Contents_List" }
const _hoisted_11 = { class: "SearchDetail_Contents" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "取引条件", -1))
const _hoisted_13 = { class: "SearchDetail_Contents_List" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "SearchDetail_Contents" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "注文種別", -1))
const _hoisted_17 = { class: "SearchDetail_Contents_List" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "(全件)", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "0:補充", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "1:客注", -1))
const _hoisted_21 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { class: "SearchDetail_Contents" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "商品コード", -1))
const _hoisted_24 = { class: "SearchDetail_Contents_List" }
const _hoisted_25 = { class: "SearchDetail_Contents" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "受注登録日", -1))
const _hoisted_27 = { class: "SearchDetail_Contents_List" }
const _hoisted_28 = ["value"]
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "Flex_Wrapper" }
const _hoisted_31 = {
  class: "Flex_Child",
  style: {"width":"auto"}
}
const _hoisted_32 = { class: "SearchDetail_Contents" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "カテゴリ", -1))
const _hoisted_34 = {
  class: "SearchDetail_Contents_List",
  style: {"width":"230px"}
}
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "Flex_Child" }
const _hoisted_37 = { class: "SearchDetail_Contents" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "入力担当者", -1))
const _hoisted_39 = {
  class: "SearchDetail_Contents_List",
  style: {"width":"230px"}
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "(全件)", -1))
const _hoisted_41 = ["value"]
const _hoisted_42 = { class: "Flex_Wrapper" }
const _hoisted_43 = { class: "Flex_Child_Short" }
const _hoisted_44 = { class: "SearchDetail_Contents" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "営業担当者", -1))
const _hoisted_46 = { class: "SearchDetail_Contents_List" }
const _hoisted_47 = ["value"]
const _hoisted_48 = { class: "Flex_Child_Long" }
const _hoisted_49 = { class: "SearchDetail_Contents" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "社内備考", -1))
const _hoisted_51 = {
  class: "SearchDetail_Contents_List",
  style: {"width":"230px"}
}

import { reactive, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import ModalShopList from "@/components/modal/ModalShopList.vue";
// import ModalItemList from "@/components/modal/ModalItemList.vue";
import ModalSyosiList from "../modal/ModalSyosiList.vue";
import InputText from "@/components/atoms/Input/InputText.vue";
import SelectNormal from "@/components/atoms/select/SelectNormal.vue";
import { Notyf } from "notyf";

type SelectedSyoten = typeof selectedSyoten;
type SelectedItem = typeof selectedItem;

//カテゴリ
type SearchConditions = typeof searchConditions;


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchConfirmDetail',
  emits: ["onSearch"],
  setup(__props, { expose: __expose, emit: __emit }) {

const store = useStore();
const emit = __emit;
const notyf = new Notyf();

let order_syubetu_list = reactive([
  { name: "(全件)", selectFlg: false },
  { name: "0:補充", selectFlg: false },
  { name: "1:客注", selectFlg: false },
  { name: "Z:保留", selectFlg: false },
]);
let modalName = ref("");
let selectedSyoten = reactive({
  syotenMei: "",
  syotenCd: "",
  toritugiCd: "",
  toritugiSyotenCd: "",
  bansen: "",
});
let selectedItem = reactive({
  item_name: "",
  // id: "",
  // selectFlg: false,
});
const categoryList = store.getters["constant/getCategoryList"];
//営業担当者
const salesList = store.getters["constant/getSalesList"];
//取引条件
const torihikiList = store.getters["constant/getTorihikiList"];
//入力担当者
const inputUserList = store.getters["constant/getInputUserList"];

//検索条件設定用
let searchConditions = reactive({
  fromTourokuDate: "",
  toTourokuDate: "",
  bansen: "",
  torihikiCd: "1",
  juchuKbn: "",
  categoryCd: "",
  userId: "",
  salesName: "",
  companyRemarks: "",
  syosiCd: "",
  toritugiCd: "",
  toritugiSyotenCd: "",
  syotenCd: "",
  syotenMei: "",
});
// 検索条件の型
watch(searchConditions, () => {
  // console.log("confirmDetailのwatch１");
  store.commit("search/setOrderRefDetailState", searchConditions);
});
watch(searchConditions, () => {
  // console.log("confirmDetailのwatch２");
  store.commit("search/setSyotenDetailState", searchConditions);
});
//検索条件設定
const inputCondition = (event: string, key: keyof SearchConditions) => {
  searchConditions[key] = event;
};
//書誌系は検索未連携
// const inputSyosiCd = (event) => {
//   searchConditions.inputSyosiCd = event.target.value;
// }
// const inputSyosiMei = (event) => {
//   searchConditions.
// }

// const selectOrderSyubetu = (syubetu) => {
//   if (!status.selectFlg) {
//     order_syubetu_list.forEach((syubetu) => {
//       syubetu.selectFlg = false;
//     });
//     syubetu.selectFlg = true;
//   } else {
//     syubetu.selectFlg = !syubetu.selectFlg;
//   }
// };
//モーダル開閉---------------------------
const showSampleModal = (openModalName: string) => {
  modalName.value = openModalName;
};
const closeSampleModal = () => {
  modalName.value = "";
};
//プロパティごとに代入するとリアクティブが効くが、丸ごと代入は利かない
const ref_selectSyoten = (selectedValue: { [x: string]: any }) => {
  Object.keys(selectedSyoten).forEach((key) => {
    selectedSyoten[key as keyof SelectedSyoten] = selectedValue[key];
    searchConditions[key as keyof SearchConditions] = selectedValue[key];
  });
};
const ref_selectItem = (selectedValue: { title: string; syosiCd: string }) => {
  searchConditions.syosiCd = selectedValue.syosiCd;
  selectedItem.item_name = selectedValue.title;
  // selectedItem.id = selectedValue.id;
  // selectedItem.selectFlg = selectedValue.selectFlg;
};
const searchSyoten = async (): Promise<void> => {
  // 入力値が空だったら各値をリセットする
  if (searchConditions.toritugiSyotenCd === "") {
    selectedSyoten.syotenMei = "";
    selectedSyoten.syotenCd = "";
    // selectedSyoten.toritugiCd = "";
    selectedSyoten.toritugiSyotenCd = "";
    selectedSyoten.bansen = "";

    // searchConditions.toritugiCd = "";
    searchConditions.toritugiSyotenCd = "";
    searchConditions.syotenCd = "";
    searchConditions.bansen = "";
    searchConditions.syotenMei = "";
  } else {
    await store.dispatch("search/searchToritugiSyotenCd");
    const res = store.getters["search/getSyotenData"];

    if (res.syotenToritugiList.length > 0) {
      ref_selectSyoten(res.syotenToritugiList[0]);
    } else {
      //該当する書店が無ければ以前の状態に戻す
      searchConditions.toritugiSyotenCd = selectedSyoten.toritugiSyotenCd;
      notyf.error("該当する書店がありません");

      // //該当する書店が無ければリセット
      // Object.keys(selectedSyoten).forEach((key) => {
      //   if (key !== "toritugiSyotenCd") {
      //     selectedSyoten[key] = "";
      //   }
      // });
    }
  }
};
//取次(「全件」項目を追加)
const zenken = { toritugiCd: "", torihikisakiCd: "", toritugiMei: "全件" };
const toritugiList = [zenken, ...store.getters["constant/getToritugiList"]];

const inputToritugi = (e?: Event) => {
  if (!e) {
    // searchConditions.toritugiCd = "101";
    searchConditions.toritugiCd = "";
  } else {
    searchConditions.toritugiCd = (e.target as HTMLInputElement).value;
    selectedSyoten.toritugiSyotenCd = "";
  }
  if (
    searchConditions.syotenMei !== "" ||
    searchConditions.bansen !== "" ||
    searchConditions.toritugiSyotenCd !== ""
  ) {
    searchConditions.syotenMei = "";
    searchConditions.bansen = "";
    searchConditions.toritugiSyotenCd = "";
  }
};
inputToritugi();
//取次書店CD
const inputToritugiSyotenCd = (e: string) => {
  searchConditions.toritugiSyotenCd = e;
};

// orderHeaderから条件リセットボタンが押されたときに発火
const resetConditions = () => {
  searchConditions.fromTourokuDate = "";
  searchConditions.toTourokuDate = "";
  searchConditions.bansen = "";
  searchConditions.torihikiCd = "";
  searchConditions.juchuKbn = "";
  searchConditions.categoryCd = "";
  searchConditions.userId = "";
  searchConditions.salesName = "";
  searchConditions.companyRemarks = "";
  searchConditions.syosiCd = "";
  searchConditions.toritugiCd = "";
  searchConditions.toritugiSyotenCd = "";
  searchConditions.syotenCd = "";
  searchConditions.syotenMei = "";

  selectedItem.item_name = "";
};

__expose({
  resetConditions,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(modalName) === 'shopModal')
      ? (_openBlock(), _createBlock(ModalShopList, {
          key: 0,
          toritugiCd: _unref(searchConditions).toritugiCd,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (closeSampleModal())),
          onRef_selectSyoten: ref_selectSyoten
        }, null, 8, ["toritugiCd"]))
      : _createCommentVNode("", true),
    (_unref(modalName) === 'itemModal')
      ? (_openBlock(), _createBlock(ModalSyosiList, {
          key: 1,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (closeSampleModal())),
          onRef_selectSyosi: ref_selectItem
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("select", {
              onChange: inputToritugi,
              value: _unref(searchConditions).toritugiCd
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(toritugiList, (option, index) => {
                return _createElementVNode("option", {
                  value: option.toritugiCd,
                  key: index
                }, _toDisplayString(option.toritugiMei), 9, _hoisted_7)
              }), 64))
            ], 40, _hoisted_6)
          ])
        ]),
        _createElementVNode("li", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(InputText, {
              class: "SearchDetail_Input_Yellow",
              onDblclick: _cache[2] || (_cache[2] = ($event: any) => (showSampleModal('shopModal'))),
              value: _unref(searchConditions).toritugiSyotenCd,
              type: 'text',
              onOnInput: inputToritugiSyotenCd,
              onOnChange: searchSyoten,
              onkeydown: "return event.keyCode !== 69"
            }, null, 8, ["value"]),
            _createVNode(InputText, {
              class: "SearchDetail_Input_Gray",
              value: _unref(searchConditions).syotenMei
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("li", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchConditions).torihikiCd) = $event)),
              class: "CartNormal_ListContent_Select"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(torihikiList), (option, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: option.torihikiCd,
                  key: index
                }, _toDisplayString(option.torihikiMei), 9, _hoisted_14))
              }), 128))
            ], 512), [
              [_vModelSelect, _unref(searchConditions).torihikiCd]
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("select", {
              name: "",
              id: "",
              class: "CartNormal_ListContent_Select",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchConditions).juchuKbn) = $event))
            }, _hoisted_21, 512), [
              [_vModelSelect, _unref(searchConditions).juchuKbn]
            ])
          ])
        ])
      ]),
      _createElementVNode("ul", null, [
        _createElementVNode("li", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createVNode(InputText, {
              class: "SearchDetail_Input_Yellow",
              onDblclick: _cache[5] || (_cache[5] = ($event: any) => (showSampleModal('itemModal'))),
              onInput: _cache[6] || (_cache[6] = ($event: any) => (inputCondition($event.target.value, 'syosiCd'))),
              value: _unref(searchConditions).syosiCd,
              type: 'number'
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("li", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("input", {
              value: _unref(searchConditions).fromTourokuDate,
              onChange: _cache[7] || (_cache[7] = ($event: any) => (inputCondition(($event.target as HTMLInputElement).value, 'fromTourokuDate'))),
              type: "date"
            }, null, 40, _hoisted_28),
            _createTextVNode("～"),
            _createElementVNode("input", {
              value: _unref(searchConditions).toTourokuDate,
              onChange: _cache[8] || (_cache[8] = ($event: any) => (inputCondition(($event.target as HTMLInputElement).value, 'toTourokuDate'))),
              type: "date"
            }, null, 40, _hoisted_29)
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("li", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(searchConditions).categoryCd) = $event)),
                  style: {"width":"200px"}
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categoryList), (option, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: option.categoryCd,
                      key: index
                    }, _toDisplayString(option.category), 9, _hoisted_35))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _unref(searchConditions).categoryCd]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("li", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("div", _hoisted_39, [
                _withDirectives(_createElementVNode("select", {
                  name: "",
                  id: "",
                  class: "CartNormal_ListContent_Select",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(searchConditions).userId) = $event))
                }, [
                  _hoisted_40,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(inputUserList), (option, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: option.userId,
                      key: index
                    }, _toDisplayString(option.username), 9, _hoisted_41))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _unref(searchConditions).userId]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("li", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(searchConditions).salesName) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(salesList), (option, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: option.salesCd,
                      key: index
                    }, _toDisplayString(option.salesName), 9, _hoisted_47))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _unref(searchConditions).salesName]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("li", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("div", _hoisted_51, [
                _createVNode(InputText, {
                  onOnInput: _cache[12] || (_cache[12] = ($event: any) => (inputCondition($event, 'companyRemarks'))),
                  value: _unref(searchConditions).companyRemarks
                }, null, 8, ["value"])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})